var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Informações do Servidor"}},[_c('InformacoesServidor')],1),_c('CTab',{attrs:{"title":"Requisições"}},[_c('LogsRequisicoes')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }